import { PostHogConfig } from 'posthog-js';

const APP_STAGE = import.meta.env.VITE_APP_STAGE || 'dev';

export const POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY;
// Only production routes through the reverse proxy (proxy is enabled for the
// prod PostHog project only); other stages hit PostHog directly.
export const POSTHOG_API_HOST =
  APP_STAGE === 'prod' ? 'https://t.ai-ark.com' : 'https://us.i.posthog.com';
export const POSTHOG_UI_HOST = 'https://us.posthog.com';

export const AI_BEES_EMAIL_DOMAINS = ['@ai-bees.io', '@ai-ark.io'] as const;

export const POSTHOG_CONFIG: Partial<PostHogConfig> = {
  api_host: POSTHOG_API_HOST,
  ui_host: POSTHOG_UI_HOST,
  autocapture: true,
  // 'history_change' captures pageviews on SPA route changes, not just hard
  // loads (the app is a client-side-routed SPA).
  capture_pageview: 'history_change',
  capture_pageleave: true,
  disable_session_recording: false,
  debug: APP_STAGE === 'dev',
};
